import React, { Component } from 'react';
import './../css/master.css';
import './../css/quality.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL 		= '';
var queryString 	= require('querystring');
var lstQuality 		= [];
var COL_QUALITYID 	= 'td:eq(0)';
var COL_QUALITY 	= 'td:eq(1)';

class Quality extends Component {
  constructor(props){
	super(props);
	this.state={
		quality:[],
		flg:true,
		loader:'none',
		opacity:1,
	}
  }
  
  componentDidMount =()=> {
	this.setState({loader:'block', opacity:0.5});  
	  axiosInstance.get(httpURL+'/a/mst/qlty/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					quality:response.data.lstQuality,
				})
				lstQuality = this.state.quality;
				this.setQualityTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  }); 
  }
  
  setQualityTable =()=> {
		$('#qualityTableBody tr').remove();
		var table 				= document.getElementById('qualityTable');
		var tbody 				= document.getElementById('qualityTableBody');
		var filterQuality 		= $('#quality').val().toLowerCase();
		
		for(var i=0; i<lstQuality.length; i++){
		var id 			= lstQuality[i].qualityId;
		var quality		= lstQuality[i].quality;
		
		var row = document.createElement('tr');
			row.id = id;
		row.onclick =(e)=>{
			$($(e.target).closest('tr')).addClass('selected').siblings().removeClass('selected');
			this.setQualityForm($(e.target).closest('tr').attr('id'));
			this.setState({flg:false})
		}
		
		if(quality.toLowerCase().indexOf(filterQuality) === -1)
			continue;
		
		this.addTD(row, id, 'no-display');
		this.addTD(row, quality, '');
		
		tbody.append(row);
		}
	table.append(tbody);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	setQualityForm =(id)=> {
		var qualityData = this.getQualityData(id);
		if(qualityData !== -1){
			$('#inp_quality').val(qualityData.quality);
		}
	}
	
	getQualityData(id){
		for(var i = 0; i < lstQuality.length; i++){
			if(id == lstQuality[i].qualityId){
				return lstQuality[i];
			}
		}
		return -1;
	}
	
	addQualityReady =()=>{
		$('#qualityAddForm').trigger('reset');
		this.setState({flg:true})
	}
	
	maintainQuality =()=>{
		if(this.state.flg){
			this.addQuality();
		}else{
			this.editQuality();
		}
	}
	
	addQuality=()=>{
	var qualityArr 		= {};
	var quality			= $('#inp_quality').val().toUpperCase();
	if(quality == ''){
		toast.warning('Please fill quality');
		document.getElementById('inp_quality').focus();
		return false;
	}
	
	qualityArr={'qualityId': 0, 'quality':quality}
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/a/mst/qlty/save', 
		queryString.stringify({'quality':JSON.stringify(qualityArr)}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
			toast.success(response.data.SvcMsg);
			qualityArr.qualityId = response.data.qualityId;
			lstQuality.push(qualityArr);
			this.setQualityTable();
			this.setQualityForm(response.data.qualityId);
			this.highlightRow('qualityTableBody', response.data.qualityId);
			this.setState({flg : false})
		}
		else{
			toast.error(response.data.SvcMsg);
		}
		this.setState({loader:'none', opacity:1});
 	}).catch((e)=>{
         toast.error("Service failed "+e);
  	});
  }

	editQuality=()=>{
		var qualityArr 		= {};
		var qualityId 		= $('#qualityTableBody tr.selected').find(COL_QUALITYID).text();
		var quality			= $('#inp_quality').val().toUpperCase();
		
		if(qualityId == ''){
			toast.warning('Please select row');
			return false;
		}
		
		if(quality == ''){
			toast.warning('Please fill quality');
			document.getElementById('inp_quality').focus();
			return false;
		}
		
		qualityArr={'qualityId': qualityId, 'quality':quality}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/qlty/save', 
			queryString.stringify({'quality':JSON.stringify(qualityArr)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var qualityIdx = this.getIdxQuality(qualityId);
				lstQuality.splice(qualityIdx,1,qualityArr);
				this.setQualityForm(qualityId);
				this.setQualityTable();
				this.highlightRow('qualityTableBody', qualityId);
			}
			else{
		        toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxQuality(qualityId){
		for(var i=0; i<lstQuality.length; i++){
			if(lstQuality[i].qualityId == qualityId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var qualityId = $(this).find(COL_QUALITYID).text();
			if(qualityId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	
  render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-7 col-centered">
						<div className="col-sm-5 col-xs-11 padding-remove">
							<table className="tableLayout">
								<thead>
									<tr>
										<th style={{width:50, display:'none'}}>Quality Id</th>
										<th style={{width:100}}>
											<input onChange={this.setQualityTable} type="text" className="form-control inp-search" id="quality" placeholder="Quality" />
										</th>
									</tr>
								</thead>
							</table>
							<div className="qualityTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="qualityTable" className="tableLayout">
									<colgroup>
										<col width="100" />
									</colgroup>
									<tbody id="qualityTableBody"></tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addQuality" title="Add Quality" onClick={this.addQualityReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-6 col-xs-12">
							<form id="qualityAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Quality:</label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Quality" id="inp_quality"/>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainQuality} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default Quality;
